<template>
  <styled-search-wrapper :open="searchIsFocus || internalSearch.length">
    <ul
      class="payment-methods__search"
      :open="searchIsFocus || internalSearch.length"
      :class="{ 'payment-methods__search--open': searchIsFocus || internalSearch.length }"
    >
      <!-- <li v-if="showGeo" v-show="false">
      <location-icon-svg class="location-icon"/>
      </li>-->

      <li
        class="payment-methods__search-tab"
        :class="{ 'payment-methods__search-tab--open': searchIsFocus || internalSearch.length }"
        :style="searchWidth"
        @click="toggleInput"
      >
        <div>
          <search-svg />
        </div>

        <input
          ref="searchInput"
          v-model.trim="internalSearch"
          type="text"
          class="text-input"
          :placeholder="$i18n.t('search')"
          @blur="blurSearch"
          @focus="focusSearch"
        />
      </li>
    </ul>
  </styled-search-wrapper>
</template>

<script>
// import Tooltip from "@/components/Tooltip";
import SearchSvg from '@/components/svg/Search';
import { mapGetters } from 'vuex';
import styled from 'vue-styled-components';

const styledSearch = styled('ul')`
  border-bottom: 2px solid #d7d9dc;
  cursor: pointer;
`;
const styledSearchInput = styled('input')``;

const styledSearchWrapper = styled.section`
  .payment-methods__search {
    border-bottom: 2px solid var(--border_color);
    transition: var(--default_transition);
    &:hover {
      border-color: var(--primary);
      .payment-methods__search-tab {
        color: var(--primary);
        .text-input {
          color: var(--primary);
          &::placeholder {
            color: var(--primary);
          }
        }
        svg path {
          fill: var(--primary);
        }
        &--open {
          .text-input {
            &::placeholder {
              color: var(--placeholder_text_color);
            }
          }
        }
      }
    }
    &--open {
      border-color: var(--primary);
    }
  }
  .payment-methods__search-tab {
    border: none;
    .text-input {
      background-color: transparent;
      &::placeholder {
        color: var(--placeholder_text_color);
      }
    }
    &--open {
      svg path {
        fill: var(--primary);
      }
      .text-input {
        color: var(--primary_text_color) !important;
        &::placeholder {
          color: var(--placeholder_text_color);
        }
      }

      &:hover {
        color: var(--primary_text_color) !important;
        .text-input {
          &::placeholder {
            color: var(--placeholder_text_color);
          }
        }
        svg path {
          fill: var(--primary);
        }
      }
    }
  }
`;

export default {
  name: 'InputSearchComponent',

  data() {
    return {
      searchIsFocus: false,
      internalSearch: '',
      showTooltip: false,
    };
  },

  watch: {
    internalSearch(value) {
      if (value === '') value = '';
      this.$emit('searchChange', value);
    },
  },

  computed: {
    searchWidth() {
      if (!this.searchIsFocus && !this.internalSearch.length) {
        return {
          width: '75px',
        };
      } else {
        return {
          width: '175px',
        };
      }
    },
  },

  methods: {
    focusSearch() {
      this.searchIsFocus = true;
    },

    blurSearch() {
      this.searchIsFocus = false;
    },

    toggleInput() {
      if (!this.searchIsFocus) {
        this.$refs.searchInput.focus();
      }
    },

    clearInput() {
      console.log('Clean input');
      this.internalSearch = '';
      this.blurSearch();
    },

    // toggleTooltip(e) {
    //   this.showTooltip = e;
    // }
  },

  components: {
    SearchSvg,
    styledSearchWrapper,
  },

  props: {
    searchData: {
      type: String,
      default: '',
    },
  },
};
</script>
